export const APP_ROUTES = {
  forbidden: 'forbidden',
  playerProfile: 'player',
};
